export function getMessagePart(message, part) {
  if (!message || !part) {
    return "";
  }
  part = part.toLowerCase();
  if (["detail", "text", "plain"].includes(part)) {
    part = "text";
  } else if (["email", "html", "rich"].includes(part)) {
    part = "html";
  } else {
    return "";
  }
  const doctypeIndex = message.search(/<!doctype html/i);
  if (doctypeIndex === -1) {
    return "";
  }
  message =
    part === "html"
      ? message.slice(doctypeIndex)
      : message.slice(0, doctypeIndex);
  return message.replace(
    /^\s*(?:<\/?br ?\/?>\s*)+|\s*(?:<\/?br ?\/?>\s*)+$/gi,
    ""
  );
}
